import { Directive, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, Output, Renderer2, SimpleChanges } from '@angular/core';
import { FileServerService } from '@app/core/services/file-server.service';
import { Subscription } from 'rxjs';

@Directive({
    selector: 'img[ttImageSrc]',
    standalone: false,
})
export class ImageSrcDirective implements OnChanges, OnDestroy {
    @Input()
    public ttImageSrc: string = '';

    @Output()
    public ttImageSrcError = new EventEmitter<void>();

    private request?: Subscription;

    private objectUrl?: string;

    constructor(
        private elementRef: ElementRef<HTMLImageElement>,
        private renderer: Renderer2,
        private fileServer: FileServerService,
    ) {}

    private load(url: string): void {
        this.request?.unsubscribe();
        this.revokeObjectUrl();
        this.renderer.removeAttribute(this.elementRef.nativeElement, 'src');

        if (!url) return;

        if (url.startsWith('data:') || url.startsWith('blob:')) {
            this.renderer.setAttribute(this.elementRef.nativeElement, 'src', url);
            return;
        }

        this.request = this.fileServer.getBlob(url).subscribe({
            next: (blob) => {
                this.objectUrl = URL.createObjectURL(blob);
                this.renderer.setAttribute(this.elementRef.nativeElement, 'src', this.objectUrl);
            },
            error: () => {
                this.renderer.removeAttribute(this.elementRef.nativeElement, 'src');
                this.ttImageSrcError.emit();
            },
        });
    }

    private revokeObjectUrl(): void {
        if (!this.objectUrl) return;

        URL.revokeObjectURL(this.objectUrl);
        this.objectUrl = undefined;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['ttImageSrc']) {
            this.load(changes['ttImageSrc'].currentValue?.trim() ?? '');
        }
    }

    ngOnDestroy(): void {
        this.request?.unsubscribe();
        this.revokeObjectUrl();
    }
}
